/**
 * TeamUnmeasuredSection — секция правок, которая не строилась.
 *
 * Раздел «Работа команды» держится на журнале правок кабинета. Журнала за
 * период может не быть вовсе: проект завели в AdSensor позже начала
 * периода — наблюдать было нечем. Раньше этаж в таком случае молча
 * исчезал, и руководитель видел пропавший раздел рядом с полным баллом за
 * регулярность работы: непонятно, всё в порядке или что-то сломалось.
 *
 * Поэтому здесь не пустота, а две фразы: почему правок нет и почему балл
 * полный. Вторая дублирует заметку генератора в разборе балла намеренно —
 * разбор свёрнут по умолчанию, и на него полагаться нельзя.
 *
 * @format
 */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

import {Stack} from 'ui/components/layout/Stack';
import {text} from 'ui/theme/typography';
import {surfaceVar} from 'ui/theme/surfaceContext';

import {EDITS_UNMEASURED_SCORE, editsUnmeasuredReason} from '../content';
import {MEASURE} from '../helpers';
import type {EditsStatusReason} from '../types';
import {ReportCard} from './ReportCard';

export interface TeamUnmeasuredSectionProps {
  /** Почему секция не строилась. Пусто — причину источник не назвал. */
  reason?: EditsStatusReason | null;
}

const Body = styled(Box)({
  ...text('body.m'),
  color: surfaceVar('onSurfaceLight'),
  maxWidth: MEASURE,
});

export function TeamUnmeasuredSection({reason}: TeamUnmeasuredSectionProps) {
  return (
    <ReportCard padding='l'>
      <Stack gap='s'>
        <Body>{editsUnmeasuredReason(reason)}</Body>
        <Body>{EDITS_UNMEASURED_SCORE}</Body>
      </Stack>
    </ReportCard>
  );
}
